import { cn } from "@/common/helpers/utils";

const DEFAULT_DOT_SPACING = 10;
const DEFAULT_DOT_RADIUS = 1.1;

interface DotArtProps {
  rows: readonly string[];
  radius?: number;
  className?: string;
}

export function DotArt({ rows, radius = DEFAULT_DOT_RADIUS, className }: DotArtProps) {
  const width = rows.reduce((max, row) => Math.max(max, row.length), 0) * DEFAULT_DOT_SPACING;
  const height = rows.length * DEFAULT_DOT_SPACING;
  const dots = rows.flatMap((row, rowIndex) =>
    [...row].flatMap((cell, colIndex) =>
      cell === "#"
        ? [
            {
              key: `${rowIndex}-${colIndex}`,
              cx: colIndex * DEFAULT_DOT_SPACING + DEFAULT_DOT_SPACING / 2,
              cy: rowIndex * DEFAULT_DOT_SPACING + DEFAULT_DOT_SPACING / 2,
            },
          ]
        : [],
    ),
  );

  return (
    <svg aria-hidden viewBox={`0 0 ${width} ${height}`} className={cn("pointer-events-none select-none", className)}>
      {dots.map((dot) => (
        <circle key={dot.key} cx={dot.cx} cy={dot.cy} r={radius} fill="currentColor" />
      ))}
    </svg>
  );
}
